const invertedMessages = {
  Close: 'CloseLabel',
  'Please try again.': 'certs.please.try.again',
  Comments: 'User_CERTCOMMENTS.ATTESTATIONS',
};

export default invertedMessages;
